import { render, staticRenderFns } from "./AuctionOtherFees.vue?vue&type=template&id=6a4bdc78&"
import script from "./AuctionOtherFees.vue?vue&type=script&lang=js&"
export * from "./AuctionOtherFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports